import React from 'react';
import { Tooltip, Icon } from 'antd';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { ENV } from '@/services/utils';
import { getPathHeader } from '../../../../../utils/utils';
import { getAppCode } from '../../utils/utils';

const hostName = {
  test: 'test.m.xiaoyuanhao.com',
  dev: 'test.m.xiaoyuanhao.com',
  production: 'm.xiaoyuanhao.com',
};

const columns = ({ startMonth, endMonth, activeKey, isPerson }) => [
  {
    title: '分组',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: (
      <div>
        10w+文章数&nbsp;
        <Tooltip title="阅读次数超过10万的文章数量">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'newsCounts',
    key: 'newsCounts',
    width: 250,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    render: (text, record) => {
      const { nodeId = '', detail } = record || {};
      const typeValue =
        // 1为学校/2为教育局
        // eslint-disable-next-line no-nested-ternary
        detail === 1 && activeKey === 'key1'
          ? 'detail'
          : detail === 1 && activeKey === 'key2'
          ? 'editor'
          : 'columns';
      const params = `appCode=${getAppCode()}&nodeId=${nodeId}&type=${typeValue}&activeKey=${activeKey}&startMonth=${startMonth}&endMonth=${endMonth}&isPerson=${isPerson}`;
      const url = `/${getPathHeader()}/manuscriptCount/hotstatistics/detail/${typeValue}?${params}`;
      return <a onClick={() => router.push(url)}>详情</a>;
    },
  },
];

const detailColumns = [
  {
    title: '组织名称',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '阅读次数',
    dataIndex: 'clickCounts',
    key: 'clickCounts',
  },
  {
    title: '点赞数',
    dataIndex: 'praiseCounts',
    key: 'praiseCounts',
  },
  {
    title: '详情',
    dataIndex: 'newsId',
    key: 'newsId',
    render: text => {
      return (
        <a
          onClick={() =>
            window.open(`//${hostName[ENV]}/micro/app/micrositeV4/articleDetail?id=${text}`)
          }
        >
          详情
        </a>
      );
    },
  },
];

const editorColums = [
  {
    title: '组织名称',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: '通讯员',
    dataIndex: 'publishUserName',
    key: 'publishUserName',
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '阅读次数',
    dataIndex: 'clickCounts',
    key: 'clickCounts',
  },
  {
    title: '点赞数',
    dataIndex: 'praiseCounts',
    key: 'praiseCounts',
  },
  {
    title: '详情',
    dataIndex: 'newsId',
    key: 'newsId',
    render: text => {
      return (
        <a
          onClick={() =>
            window.open(`//${hostName[ENV]}/micro/app/micrositeV4/articleDetail?id=${text}`)
          }
        >
          详情
        </a>
      );
    },
  },
];

export { columns, detailColumns, editorColums };
